import { signInWithRedirect, signOut } from 'aws-amplify/auth';
import IndicatorScreen from 'components/indicator/IndicatorScreen';
import { useEffect } from 'react';

/**
 *　代理ログイン中継画面
 */
export default function ProxyLogin(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */
  useEffect(() => {
    const handleSsoLogin = async () => {
      try {
        await signOut();
        await signInWithRedirect();
      } catch (error) {
        console.error(error);
        alert('管理画面で再ログインをお試しください');
      }
    };

    handleSsoLogin();
  }, []);

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      {/* ローディング中の表示 */}
      <IndicatorScreen visible={true} />
    </>
  );
}
